import { render, staticRenderFns } from "./trafficStatistics.vue?vue&type=template&id=2d16e078&"
import script from "./trafficStatistics.vue?vue&type=script&lang=js&"
export * from "./trafficStatistics.vue?vue&type=script&lang=js&"
import style0 from "./trafficStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports